import { makeStyles } from "@material-ui/core/styles";
import LoadingProgress from "./LoadingProgress";
import React from "react";
import { Backdrop } from "@material-ui/core";

const useStyles = makeStyles((theme) => ({
  root: {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translateY(-50%) translateX(-50%)'
  },
  backdrop: {
    zIndex: theme.zIndex.drawer + 1,
    backgroundColor: 'rgba(0,0,0,.3)'
  }
}));

export const Loading = ({backdrop, text}) => {
  const classes = useStyles();
  return (
    <>
      {backdrop &&
        <Backdrop open={backdrop} className={classes.backdrop}>
          <LoadingProgress text={text}/>
        </Backdrop>
      }
      {!backdrop &&
        <div className={classes.root}>
          <LoadingProgress text={text}/>
        </div>
      }
    </>
  )
};
